<template>
  <Row>
    <Row type="flex" justify="end" style="margin:12px 0">
      <Page
        :current="page.current"
        show-total
        :total="page.total"
        size="small"
        @on-change="changePage"
        show-sizer
        :page-size="page.limit"
        @on-page-size-change="changeLimit"
        :page-size-opts="[10, 20, 30, 40, 50, 60, 80]"
      ></Page>
      <i-button size="small" @click="download">
        <FFIcon type="download" aria-hidden="true" /> download
      </i-button>
    </Row>

    <Row>
      <i-table
        size="small"
        :data="dataset"
        :columns="columns"
        @on-sort-change="sortTable"
      ></i-table>
    </Row>

    <Row type="flex" justify="end" style="margin:12px 0">
      <Page
        :current="page.current"
        show-total
        :total="page.total"
        size="small"
        @on-change="changePage"
        show-sizer
        :page-size="page.limit"
        @on-page-size-change="changeLimit"
        :page-size-opts="[10, 20, 30, 40, 50, 60, 80]"
      ></Page>
      <i-button size="small" @click="download">
        <FFIcon type="download" aria-hidden="true" /> download
      </i-button>
    </Row>
  </Row>
</template>

<script>
import tableActions from "@/mixins/table_actions.js";
import pagination from "@/mixins/pagination.js";
import sort from "@/mixins/sort.js";

export default {
  mixins: [tableActions, pagination, sort],
  props: ["conditions", "limit"],

  data() {
    return {
      tableURL: "publishers_view",
      dataset: [],
    };
  },

  computed: {
    // Dynamically defines the table column
    columns() {
      return [
        { title: "GSN", key: "gsn", width: 140 },
        // ----- Name
        {
          title: "Name",
          key: "name",
          sortable: "custom",
          sortType: this.sort.name || "normal",
          render: (h, params) =>
            h("div", [
              h(
                "router-link",
                {
                  attrs: {
                    to: "/publishers/" + params.row.id,
                  },
                },
                [h("span", params.row.name)]
              ),
            ]),
        },
        // ----- Country
        {
          title: "Country",
          key: "geo_name",
          sortable: "custom",
          sortType: this.sort.geo_name || "normal",
          width: 230,
        },
        // ----- Type
        {
          title: "Type",
          key: "type",
          sortable: "custom",
          sortType: this.sort.type || "normal",
          width: 230,
        },
      ];
    },
  },

  created() {
    this.load();
  },

  watch: {
    conditions() {
      this.load();
    },
  },
};
</script>

<style lang="css">
.ivu-table-small td {
  height: 32px;
}
</style>
